<template>
  <HSCodeCreateAdmin
          :HSCode="HSCode"
          :serverError="serverError"
          @createHSGroup="createHSGroup"
  />
</template>

<script>
  import HSCodeCreateAdmin from "./HSCodeCreateAdmin/HSCodeCreateAdmin";
  import {HSCode} from "@/components/modules/HSCodesModule/models/HSCode";
  export default {
    name: "HSCodeCreate",

    components: {
      HSCodeCreateAdmin,
    },

    mixins: [],

    data() {
      return {
        serverError: false,
        HSCode: new HSCode(),
      }
    },

    mounted() {

    },

    methods: {
      createHSGroup() {
        console.log(this.HSCode.hsGroupValidation());
        if(!this.HSCode.hsGroupValidation()) return

        let data = this.HSCode.prepareDataHsGroup()

        console.log(data);

        this.$store.dispatch('createHSCodesGroups', data).then(response => {
          switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
              this.openNotify('success', 'common_notificationRecordCreated')
              this.$router.push(this.$store.getters.GET_PATHS.mainSettingsHSCodes)
              break
            }
              /**
               * Validation Error
               */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
              /**
               * Undefined Error
               */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }
        })
      },

    },

  }
</script>

<style scoped>

</style>
